'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('@emotion/react');

/**
 * 레거시 어플리케이션을 위한 임시 버전으로 nol-disign-system을 사용할 것
 * 2.0 기본 작업으로 기본 색상 변경 (pink -> blue)
 * week color 추가
 */
// nol blue 신규 색상
var blue50 = '#F5F6FF';
var blue100 = '#DFE2FF';
var blue200 = '#B2BAFF';
var blue600 = '#4154FF';
var gray50 = '#F8F8F8';
var gray100 = '#F2F2F2';
var gray200 = '#E6E6E6';
var gray400 = '#B1B1B1';
var gray500 = '#8A8A8A';
var gray600 = '#6D6D6D';
var gray900 = '#1A1A1A';
var yaorange = '#cc4100';
var yaorange50 = '#fef8f2';
var yaorange200 = '#f1b77f';
var yared = '#dc0328';
var yared200 = '#f3b3be';
var yared50 = '#fdf2f4';
var yagreen = '#008161';
var yagreen50 = '#f2f8f7';
var yagreen100 = '#D6EBE6';
var yagreen200 = '#B2D9CF';
var yagreen600 = '#008161';
var yayellow300 = '#fdbd00';
var yayellow500 = '#b46d0e';
var yagold = '#996500';
var yagold50 = '#FFFAE1';
var yagold100 = '#FEECAE';
var yagold200 = '#FDDD72';
var black = '#000000';
var white = '#ffffff';
var black_op80 = 'rgba(0, 0, 0, 0.8)';
var black_op60 = 'rgba(0, 0, 0, 0.6)';
var black_op50 = 'rgba(0, 0, 0, 0.5)';
var black_op40 = 'rgba(0, 0, 0, 0.4)';
var black_op30 = 'rgba(0, 0, 0, 0.3)';
var black_op20 = 'rgba(0, 0, 0, 0.2)';
var black_op16 = 'rgba(0, 0, 0, 0.16)';
var black_op10 = 'rgba(0, 0, 0, 0.1)';
var black_op5 = 'rgba(0, 0, 0, 0.05)';
var white_op90 = 'rgba(255, 255, 255, 0.9)';
var white_op80 = 'rgba(255, 255, 255, 0.8)';
var white_op40 = 'rgba(255, 255, 255, 0.4)';
var white_op30 = 'rgba(255, 255, 255, 0.3)';
var white_op20 = 'rgba(255, 255, 255, 0.2)';
var white_op10 = 'rgba(255, 255, 255, 0.1)';
var transparent = 'rgba(255, 255, 255, 0)';
/*
 * Color Gradient
 * */
var gradient_4color_mix = 'linear-gradient(90deg, #5177F0, #A46DC5, #FB5A90, #FF3478)';
/*
 * Legacy Color
 * */
var Ic_blue_pressed = '#2432AD';
var Ic_blue_hover = '#2432AD';
var Ic_gray_pressed = '#6D6D6D';
var Ic_gray900_op40 = 'rgba(26, 26, 26, 0.4)';
var Ic_yablue_op40 = 'rgba(1, 82, 204, 0.4)';
var Ic_yared_op40 = 'rgba(220, 3, 40, 0.4)';
var Ic_yayellow_op30 = 'rgba(253, 189, 0, 0.3)';
var Ic_widget_event1 = '#008F6C';
var Ic_widget_event2 = '#FF3600';
var Ic_widget_event3 = '#FA0E47';
var Ic_widget_event4 = '#DA06B5';
var Ic_widget_event5 = '#6100CB';
var Ic_kakao = '#FEE500';
var Ic_kakao_pressed = '#988900';
var Ic_kakao_hover = '#CBB700';
var Ic_naver = '#00C73C';
var Ic_naver_pressed = '#007724';
var Ic_naver_hover = '#009F30';
var Ic_generaltype = '#FFF4ED';
var Ic_springtype = '#FEEAE9';
var Ic_summertype = '#E7F5F5';
var Ic_falltype = '#FFF4ED';
var Ic_wintertype = '#E9ECFA';
var Ic_blue_mark1 = '#417ED9';
var Ic_blue_mark2 = '#2D70D4';
var Ic_blue_mark3 = '#0045AD';
var Ic_purple_badge = '#9948e2';
var Ic_use_coupon1 = '#00674E';
var Ic_use_coupon2 = '#015A4B';
var Ic_use_coupon_gradation = 'linear-gradient(90deg, #07C2D3, #1ADEAE)';
var Ic_gray_fb = '#FBFBFB';
var Ic_cs_banner1 = '#4C62D9';
var Ic_cs_banner2 = '#647AEC';
var lc_mint_badge = '#00B49F';
var lc_promotion_button = '#29333F';
/**
 * yanolja legacy color
 * ! 이 색상 값을 사용하고 있다면 신규 nol 색상값으로 변경이 필요
 * ! 기존 색상 유지를 위해 제거하면 안됨
 * ----------------------------------------------
 * yapink -> blue600
 * yapink50 -> blue50
 * yapink100 -> blue100
 * yapink200 -> blue200
 *
 * yablue -> gray900
 * yablue400 -> gray500
 * yablue300 -> gray400
 * yablue200 -> gray200
 * yablue100 -> gray100
 * yablue50 -> gray50
 *
 * yablue_op10 -> black_op10
 * yablue_op5 -> black_op5
 *
 * Ic_yapink_pressed -> Ic_blue_pressed
 * Ic_yapink_hover -> Ic_blue_hover
 * Ic_yablue_pressed -> Ic_gray_pressed
 * ----------------------------------------------
 */
var yapink = '#7E3DE7';
var yapink50 = '#EDE3FC';
var yapink100 = '#D8C4F8';
var yapink200 = '#AA80F0';
var yablue = '#0152cc';
var yablue50 = '#F2F6FC';
var yablue100 = '#E6EEFA';
var yablue200 = '#b3cbf0';
var yablue300 = '#80a8e5';
var yablue400 = '#4D85DB';
var yablue600 = '#0152CC';
var yablue_op10 = 'rgba(1, 82, 204, 0.1)';
var yablue_op5 = 'rgba(1, 82, 204, 0.05)';
var Ic_yapink_pressed = '#5A18C3';
var Ic_yapink_hover = '#681CE3';
var Ic_yablue_pressed = '#01317A';

var color = /*#__PURE__*/Object.freeze({
    __proto__: null,
    blue50: blue50,
    blue100: blue100,
    blue200: blue200,
    blue600: blue600,
    gray50: gray50,
    gray100: gray100,
    gray200: gray200,
    gray400: gray400,
    gray500: gray500,
    gray600: gray600,
    gray900: gray900,
    yaorange: yaorange,
    yaorange50: yaorange50,
    yaorange200: yaorange200,
    yared: yared,
    yared200: yared200,
    yared50: yared50,
    yagreen: yagreen,
    yagreen50: yagreen50,
    yagreen100: yagreen100,
    yagreen200: yagreen200,
    yagreen600: yagreen600,
    yayellow300: yayellow300,
    yayellow500: yayellow500,
    yagold: yagold,
    yagold50: yagold50,
    yagold100: yagold100,
    yagold200: yagold200,
    black: black,
    white: white,
    black_op80: black_op80,
    black_op60: black_op60,
    black_op50: black_op50,
    black_op40: black_op40,
    black_op30: black_op30,
    black_op20: black_op20,
    black_op16: black_op16,
    black_op10: black_op10,
    black_op5: black_op5,
    white_op90: white_op90,
    white_op80: white_op80,
    white_op40: white_op40,
    white_op30: white_op30,
    white_op20: white_op20,
    white_op10: white_op10,
    transparent: transparent,
    gradient_4color_mix: gradient_4color_mix,
    Ic_blue_pressed: Ic_blue_pressed,
    Ic_blue_hover: Ic_blue_hover,
    Ic_gray_pressed: Ic_gray_pressed,
    Ic_gray900_op40: Ic_gray900_op40,
    Ic_yablue_op40: Ic_yablue_op40,
    Ic_yared_op40: Ic_yared_op40,
    Ic_yayellow_op30: Ic_yayellow_op30,
    Ic_widget_event1: Ic_widget_event1,
    Ic_widget_event2: Ic_widget_event2,
    Ic_widget_event3: Ic_widget_event3,
    Ic_widget_event4: Ic_widget_event4,
    Ic_widget_event5: Ic_widget_event5,
    Ic_kakao: Ic_kakao,
    Ic_kakao_pressed: Ic_kakao_pressed,
    Ic_kakao_hover: Ic_kakao_hover,
    Ic_naver: Ic_naver,
    Ic_naver_pressed: Ic_naver_pressed,
    Ic_naver_hover: Ic_naver_hover,
    Ic_generaltype: Ic_generaltype,
    Ic_springtype: Ic_springtype,
    Ic_summertype: Ic_summertype,
    Ic_falltype: Ic_falltype,
    Ic_wintertype: Ic_wintertype,
    Ic_blue_mark1: Ic_blue_mark1,
    Ic_blue_mark2: Ic_blue_mark2,
    Ic_blue_mark3: Ic_blue_mark3,
    Ic_purple_badge: Ic_purple_badge,
    Ic_use_coupon1: Ic_use_coupon1,
    Ic_use_coupon2: Ic_use_coupon2,
    Ic_use_coupon_gradation: Ic_use_coupon_gradation,
    Ic_gray_fb: Ic_gray_fb,
    Ic_cs_banner1: Ic_cs_banner1,
    Ic_cs_banner2: Ic_cs_banner2,
    lc_mint_badge: lc_mint_badge,
    lc_promotion_button: lc_promotion_button,
    yapink: yapink,
    yapink50: yapink50,
    yapink100: yapink100,
    yapink200: yapink200,
    yablue: yablue,
    yablue50: yablue50,
    yablue100: yablue100,
    yablue200: yablue200,
    yablue300: yablue300,
    yablue400: yablue400,
    yablue600: yablue600,
    yablue_op10: yablue_op10,
    yablue_op5: yablue_op5,
    Ic_yapink_pressed: Ic_yapink_pressed,
    Ic_yapink_hover: Ic_yapink_hover,
    Ic_yablue_pressed: Ic_yablue_pressed
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var FadeIn = react.keyframes(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  from { opacity: 0 }\n  to { opacity: 1 }\n"], ["\n  from { opacity: 0 }\n  to { opacity: 1 }\n"])));
var FadeOut = react.keyframes(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  from { opacity: 1 }\n  to { opacity: 0 }\n"], ["\n  from { opacity: 1 }\n  to { opacity: 0 }\n"])));
var ScaleUp = react.keyframes(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  from { transform: scale(1) }\n  to { transform: scale(1.1) }\n"], ["\n  from { transform: scale(1) }\n  to { transform: scale(1.1) }\n"])));
var ScaleDown = react.keyframes(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  from { transform: scale(1.1) }\n  to { transform: scale(1) }\n"], ["\n  from { transform: scale(1.1) }\n  to { transform: scale(1) }\n"])));
// translate 보다 translate3D 가 모든 브라우져에서 더 나은 성능을 보여주기 때문에 translate3D 를 사용하도록 한다
var ScrollUp = react.keyframes(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  from { transform: translate3d(0, 100%, 0); opacity: 0 }\n  to { transform: translate3d(0, 0, 0); opacity: 1 }\n"], ["\n  from { transform: translate3d(0, 100%, 0); opacity: 0 }\n  to { transform: translate3d(0, 0, 0); opacity: 1 }\n"])));
var ScrollDown = react.keyframes(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  from { transform: translate3d(0, 0, 0); opacity: 1 }\n  to { transform: translate3d(0, 100%, 0); opacity: 0 }\n"], ["\n  from { transform: translate3d(0, 0, 0); opacity: 1 }\n  to { transform: translate3d(0, 100%, 0); opacity: 0 }\n"])));
var ScrollLeft = react.keyframes(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  from { transform: translate3d(0%, 0, 0) }\n  to { transform: translate3d(-100%, 0, 0) }\n"], ["\n  from { transform: translate3d(0%, 0, 0) }\n  to { transform: translate3d(-100%, 0, 0) }\n"])));
var ScrollRight = react.keyframes(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  from { transform: translate3d(-100%, 0, 0) }\n  to { transform: translate3d(0%, 0, 0) }\n"], ["\n  from { transform: translate3d(-100%, 0, 0) }\n  to { transform: translate3d(0%, 0, 0) }\n"])));
var Ripple = react.keyframes(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  to { transform: scale(4); opacity: 0; }\n"], ["\n  to { transform: scale(4); opacity: 0; }\n"])));
var Growth = react.keyframes(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  from { transform: scale(0) }\n  to { transform: scale(1) }\n"], ["\n  from { transform: scale(0) }\n  to { transform: scale(1) }\n"])));
var Shrinks = react.keyframes(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  from {\n    transform: scale(1)\n  }\n  to {\n    transform: scale(0)\n  }\n"], ["\n  from {\n    transform: scale(1)\n  }\n  to {\n    transform: scale(0)\n  }\n"])));
var Spin = react.keyframes(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  from {\n    transform: rotate(0deg)\n  }\n  to {\n    transform: rotate(360deg)\n  }\n"], ["\n  from {\n    transform: rotate(0deg)\n  }\n  to {\n    transform: rotate(360deg)\n  }\n"])));
var Blink = react.keyframes(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  0% {\n    opacity: .25;\n  }\n  35%, 70% {\n    opacity: 1;\n  }\n  100% {\n    opacity: .25;\n  }\n"], ["\n  0% {\n    opacity: .25;\n  }\n  35%, 70% {\n    opacity: 1;\n  }\n  100% {\n    opacity: .25;\n  }\n"])));
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;

var animations = /*#__PURE__*/Object.freeze({
    __proto__: null,
    FadeIn: FadeIn,
    FadeOut: FadeOut,
    ScaleUp: ScaleUp,
    ScaleDown: ScaleDown,
    ScrollUp: ScrollUp,
    ScrollDown: ScrollDown,
    ScrollLeft: ScrollLeft,
    ScrollRight: ScrollRight,
    Ripple: Ripple,
    Growth: Growth,
    Shrinks: Shrinks,
    Spin: Spin,
    Blink: Blink
});

/**
 * Serialized style 형태로 export 됨에 주의!
 * import { css } from '@emotion/react'; -> serialized css
 * import { css } from '@emotion/css'; -> class name
 */
// 스크롤바 숨기기
var HideScrollBar = react.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"], ["\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"])));
var HWAccelerator = react.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  transform: translateZ(0);\n  will-change: transform;\n"], ["\n  transform: translateZ(0);\n  will-change: transform;\n"])));
/**
 * 인터넷에서 주움
 * https://codepen.io/siiron/pen/jfBhy
 */
var LineClamp = (function (line) {
    return react.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    text-overflow: ellipsis;\n    word-break: break-word;\n    display: -webkit-box;\n    -webkit-line-clamp: ", ";\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  "], ["\n    text-overflow: ellipsis;\n    word-break: break-word;\n    display: -webkit-box;\n    -webkit-line-clamp: ", ";\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  "])), line);
});
var templateObject_1, templateObject_2, templateObject_3;

var mixin = /*#__PURE__*/Object.freeze({
    __proto__: null,
    HideScrollBar: HideScrollBar,
    HWAccelerator: HWAccelerator,
    LineClamp: LineClamp
});

var PC_WIDTH = 768;
var zIndexLow = 10;
var zIndexMiddle = 20;
var zIndexHigh = 30;
var zIndexVeryHigh = 40;
var zIndexExtra = 50;
var zIndexExtraHigh = 60;
var zIndexMax = 100;

var units = /*#__PURE__*/Object.freeze({
    __proto__: null,
    PC_WIDTH: PC_WIDTH,
    zIndexLow: zIndexLow,
    zIndexMiddle: zIndexMiddle,
    zIndexHigh: zIndexHigh,
    zIndexVeryHigh: zIndexVeryHigh,
    zIndexExtra: zIndexExtra,
    zIndexExtraHigh: zIndexExtraHigh,
    zIndexMax: zIndexMax
});

var getTypography = function (fontSize, lineHeight) { return ({
    bold: "\n    font-size: ".concat(fontSize, "rem;\n    font-weight: bold;\n    line-height: ").concat(lineHeight, "rem;\n  "),
    regular: "\n    font-size: ".concat(fontSize, "rem;\n    font-weight: normal;\n    line-height: ").concat(lineHeight, "rem;\n  "),
}); };
var _typography = {
    headline1: getTypography(4, 4.8),
    headline2: getTypography(3.2, 3.8),
    headline3: getTypography(2.4, 2.9),
    subtitle1: getTypography(2, 2.4),
    subtitle2: getTypography(1.8, 2.2),
    subtitle3: getTypography(1.6, 1.9),
    body1: getTypography(1.4, 1.7),
    body2: getTypography(1.2, 1.4),
    caption: getTypography(1.1, 1.3),
    badge: getTypography(1.0, 1.2),
    'subtitle1.multiline': getTypography(2, 3),
    'subtitle2.multiline': getTypography(1.8, 2.7),
    'subtitle3.multiline': getTypography(1.6, 2.4),
    'body1.multiline': getTypography(1.4, 2.1),
    'body2.multiline': getTypography(1.2, 1.8),
    'caption.multiline': getTypography(1.1, 1.7),
};
var Typography = function (typename) { return _typography[typename]; };

exports.Animations = animations;
exports.Color = color;
exports.Mixins = mixin;
exports.Typography = Typography;
exports.Units = units;
